<template>
  <div class="fts-date-time-range">
    <date-range-picker
      append-to-body
      :locale-data="localeData"
      :min-date="minDate"
      :max-date="maxDate"
      :single-date-picker="singleDatePicker"
      :time-picker="timePicker"
      :time-picker24-hour="timePicker24Hour"
      :show-week-numbers="showWeekNumbers"
      :show-dropdowns="showDropdowns"
      :auto-apply="autoApply"
      :ranges="ranges"
      :always-show-calendars="alwaysShowCalendars"
      :calculate-position="calculatePosition"
      control-container-class="fts-form-control picker-toggle"
      v-model="model"
      @update="update"
      @toggle="toggle"
    >
      <div slot="input" slot-scope="picker">
        <template v-if="singleDatePicker">{{format(picker.startDate)}}</template>
        <template v-else>{{format(picker.startDate)}} - {{format(picker.endDate)}}</template>
      </div>

      <div slot="ranges" slot-scope="ranges" class="ranges">
        <ul class="fts-scrollbar">
          <li 
            v-for="(range, name) in ranges.ranges" 
            :key="name" 
            :class="{'active': format(ranges.startDate) === format(range[0]) && format(ranges.endDate) === format(range[1])}"
            @click="ranges.clickRange(range)">
            {{name}}        
          </li>
        </ul>
      </div>

      <div slot="footer" slot-scope="data" class="dtr-footer">
        <div class="dtr-footer-date">{{data.rangeText}}</div>
        <fts-btn sm text @click="data.clickCancel">
          Cancel
        </fts-btn>
        <fts-btn sm color="primary" :disabled="data.in_selection" @click="data.clickApply" >
          Ok
        </fts-btn>
      </div>
    </date-range-picker>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
// import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { createPopper } from '@popperjs/core';

import commons from '../commons/commons';

import FTSBtn from "./FTSBtn";

export default {
  props: {
    minDate: {
      type: Date
    },
    maxDate: {
      type: Date
    },
    startDateKey: {
      type: String,
      default: "startDate",
    },
    endDateKey: {
      type: String,
      default: "endDate",
    },
    singleDatePicker: Boolean,
    timePicker: Boolean,
    timePicker24Hour: {
      type: Boolean,
      default: true
    },
    showWeekNumbers: Boolean,
    showDropdowns: Boolean,
    autoApply: Boolean,
    formData: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    alwaysShowCalendars: {
      type: Boolean,
      default: true
    },
    /* popper */
    popperPlacement: {
      type: String,
      default: 'bottom-start',
    },
    popperOffset: {
      type: Array,
      default: () => [0, 6],
    },
    popperZIndex: Number,
    popperPreventOverflowPadding: {
      type: Object,
      default: () => ({
        left: 60,
        right: 25,
      }),
    },
  },
  components: {
    "date-range-picker": DateRangePicker,
    "fts-btn": FTSBtn,
  },
  data() {
    let data = {
      localeData: {
        firstDay: 1,
        format: "mmm dd, yyyy"
        // format: "mmm dd, yyyy HH:MM",
      },
    };  
    // Set Range
    if (this.singleDatePicker) {
      data.ranges = {
        "No Due": [
          null,
          null
        ],
        Tomorrow: [
          moment().add(1, "days").startOf("day").toDate(),
          moment().add(1, "days").endOf("day").toDate()
        ],
        "Next Week": [
          moment().add(1, "w").startOf("day").toDate(),
          moment().add(1, "w").endOf("day").toDate(),
        ],
        "Next 2 Week": [
          moment().add(2, "w").startOf("day").toDate(),
          moment().add(2, "w").endOf("day").toDate(),
        ],
        "Next Month": [
          moment().add(1, 'M').startOf("day").toDate(),
          moment().add(1, 'M').endOf("day").toDate()
        ]
      }
    } else {
      data.ranges = {
        Yesterday: [
          moment()
            .subtract(1, "days")
            .startOf("day").toDate(),
          moment()
            .subtract(1, "days")
            .endOf("day").toDate()
        ],
        Today: [moment().startOf("day").toDate(), moment().endOf("day").toDate()],
        Tomorrow: [
          moment()
            .add(1, "days")
            .startOf("day").toDate(),
          moment()
            .add(1, "days")
            .endOf("day").toDate()
        ],
        "Last Week": [
          moment()
            .subtract(1, "weeks")
            .startOf("week").toDate(),
          moment()
            .subtract(1, "weeks")
            .endOf("week").toDate()
        ],
        "This Week": [moment().startOf("week").toDate(), moment().endOf("week").toDate()],
        "Next Week": [
          moment()
            .add(1, "weeks")
            .startOf("week").toDate(),
          moment()
            .add(1, "weeks")
            .endOf("week").toDate()
        ],
        "Last Month": [
          moment()
            .subtract(1, "months")
            .startOf("month").toDate(),
          moment()
            .subtract(1, "months")
            .endOf("month").toDate()
        ],
        "This Month": [moment().startOf("month").toDate(), moment().endOf("month").toDate()],
        "Next Month": [
          moment()
            .add(1, "months")
            .startOf("month").toDate(),
          moment()
            .add(1, "months")
            .endOf("month").toDate()
        ],
        "Last Year": [
          moment()
            .subtract(1, "years")
            .startOf("year").toDate(),
          moment()
            .subtract(1, "years")
            .endOf("year").toDate()
        ],
        "This Year": [moment().startOf("year").toDate(), moment().endOf("year").toDate()],
        "Next Year": [
          moment()
            .add(1, "years")
            .startOf("year").toDate(),
          moment()
            .add(1, "years")
            .endOf("year").toDate()
        ]
      }
    }
    // Date + Time
    if (this.timePicker) 
      data.localeData.format = "mmm dd, yyyy"
      // data.localeData.format = "mmm dd, yyyy HH:MM";
    // Return
    return data;
  },
  methods: {
    toggle(show, event) {
      this.$emit("toggle", show);
    },
    update(event) {
      this.$emit("update", event);
    },
    format(date) {
      if (date) {
        date = moment(date).format();

        if (this.timePicker) {
          if (this.item.predefinedFormatId) {
            return luxon.fromISO(date).toFormat(this.item.predefinedFormatId);
          } else {
            return luxon.fromISO(date).toFormat("DD t");
          }
        } else {
          if (this.item.predefinedFormatId) {
            return luxon.fromISO(date).toFormat(this.item.predefinedFormatId);
          } else {
            return luxon.fromISO(date).toFormat("DD");
          }
        }
      }
    },
    calculatePosition(dropdownList, component, {width, top, left, right}) {
      /* prevent overflow padding */
      const preventOverflowPL = this.popperPreventOverflowPadding && this.popperPreventOverflowPadding.left || 0;
      const preventOverflowPR = this.popperPreventOverflowPadding && this.popperPreventOverflowPadding.right || 0 
      const preventOverflowPaddingX = preventOverflowPL + preventOverflowPR;
      /* set style */
      dropdownList.style.maxHeight = "100%";
      if (this.popperZIndex)
        dropdownList.style.zIndex = this.popperZIndex;
      if (preventOverflowPaddingX)
        dropdownList.style.maxWidth = `calc(100% - ${preventOverflowPaddingX}px)`;
      /* create popper */
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.popperPlacement,
        modifiers: [
          {
            name: 'offset', 
            options: {
              offset: this.popperOffset,
            }
          },
          {
            name: 'preventOverflow',
            options: {
              padding: {
                ...this.popperPreventOverflowPadding,
              },
              altAxis: true,
              tether: false,
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({state}) {
              component.$el.classList.toggle('drop-up', state.placement === 'top')
            },
          }]
      });
      /* destory popper */
      return () => popper.destroy();
    },
    blockParentDropdown(e) {
      // Stop clicks inside the teleported picker
      if (e.target.closest('.daterangepicker')) {
        e.stopPropagation()
      }
    }
  },
  computed: {
    model: {
      get() {
        if (this.formData[this.item.fieldName] && this.singleDatePicker) 
          return {
            startDate: this.formData[this.item.fieldName],
            endDate: this.formData[this.item.fieldName]
          };
        else if (
          this.formData[this.item.fieldName] &&
          this.formData[this.item.fieldName].startDate &&
          this.formData[this.item.fieldName].endDate
        )
          return {
            startDate: this.formData[this.item.fieldName].startDate,
            endDate: this.formData[this.item.fieldName].endDate
          };
        else
          return {};
      },
      set(val) {
        if (this.singleDatePicker) {
          if (commons.isDateISO_8601(val.startDate))
            this.$set(this.formData, this.item.fieldName, moment(val.startDate).format());
          else if (this.formData[this.item.fieldName])
            this.$delete(this.formData, this.item.fieldName);
        } else {
          if (commons.isDateISO_8601(val.startDate) && commons.isDateISO_8601(val.endDate))
            this.$set(this.formData, this.item.fieldName, {
              [this.startDateKey]: moment(val.startDate).format(),
              [this.endDateKey]: moment(val.endDate).format(),
            });
          else if (this.formData[this.item.fieldName])
            this.$delete(this.formData, this.item.fieldName);
        }
        this.$emit("input", val);
      }
    }
  },
  mounted() {
    document.addEventListener('mousedown', this.blockParentDropdown, true)
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.blockParentDropdown, true)
  },
};
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;
@use "./src/assets/scss/colors" as *;

.fts-date-time-range {
  .picker-toggle {
    min-width: 175px;
    cursor: pointer;
  }
}
.daterangepicker {
  box-shadow: var(--fts-elevation-3);
  border-radius: .25rem;
  background: var(--fts-popover-alt-background);
  color: var(--fts-text);
  z-index: $z-index-popover;
  .calendars-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .drp-calendar {
      padding: 1rem;
    }
  }
  .calendar-table {
    /* control */
    @mixin calendar-control($direction: null) {
      background-color: transparent !important;
      span {
        display: inline-block;
        padding: 3px;
        border: solid var(--fts-text);
        border-width: 0 2px 2px 0;
        border-radius: 0;
        cursor: pointer !important;
      }
    }
    @include user-select-none;
    .next {
      @include calendar-control($direction: left);
      span {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
    }
    .prev {
      @include calendar-control($direction: right);
      span {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
      }
    }

    table {
      width: 100%;
      margin: 0;
      border-spacing: 0;
      border-collapse: collapse;
      display: table;
    }

    th,
    td {
      white-space: nowrap;
      text-align: center;
      vertical-align: middle;
      min-width: 32px;
      width: 32px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid transparent;
      &.available {
        background-color: var(--fts-gray-200);
        border-color: transparent;
        color: inherit;
      }
      &.week {
        font-size: 80%;
        color: #ccc;
      }
    }

    td {
      cursor: pointer;
      &.off,
      &.off.in-range,
      &.off.start-date, 
      &.off.end-date {
        border-color: transparent;
        background: var(--fts-popover-alt-background);
        color: #999;
      }
      &.in-range {
        @include theme() {
          background-color: rgba(theme-get('fts-primary'), .15);
        }
        border-radius: 0;
        border-color: transparent;
      }
      &.start-date {
        border-radius: 4px 0 0 4px;
      }
      &.end-date {
        border-radius: 0 4px 4px 0;
      }
      &.start-date.end-date {
        border-radius: 4px;
      }
      &.today {
        color: var(--fts-primary);
      }
      &.active,
      &.active:hover {
        background-color: var(--fts-primary);
        border-color: transparent;
        color: #fff;
      }
      &.month {
        width: auto;
      }
    }

    th {
      cursor: default;
      &.month {
        .row {
          display: flex;
          justify-content: space-between;
          > * {
            flex: 1 0 45%;
            max-width: 45%;
          }
        }
      }
    }

    td.disabled,
    option.disabled {
      color: #999;
      cursor: not-allowed;
      text-decoration: line-through;
    }

    select.monthselect, 
    select.yearselect {
      height: auto;
      margin: 0;
      padding: 1px;
      font-size: .75rem;
      cursor: default;
    }
  }
  .calendar-time {
    position: relative;
    display: flex;
    justify-content: center;
    // text-align: center;
    margin: 4px auto 0 auto;
    line-height: 30px;
    select {
      &.hourselect,
      &.minuteselect,
      &.secondselect,
      &.ampmselect {
        width: 50px;
        border: 1px solid var(--fts-border);
        background-color: var(--fts-gray-200);
        padding: 2px;
        outline: 0;
        font-size: .75rem;
      }
      &:disabled {
        color: #ccc;
        cursor: not-allowed;
      }
    }
  }
  .ranges {
    ul {
      max-height: 299px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      padding: .75rem .75rem 0;
      list-style: none;
    }
    li {
      margin-bottom: .375rem;
      padding: .375rem .75rem;
      border-radius: .25rem;
      font-size: .75rem;
      cursor: pointer;
      white-space: nowrap;
      &:not(:last-child)
      &:hover {
        background-color: var(--fts-gray-200);
      }
      &.active {
        background-color: var(--fts-primary);
        color: #fff;
      }
    }
  }
  .dtr-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: .575rem 1rem;
    border-top: 1px solid var(--fts-border);
    > * {
      &:not(:last-child) {
        margin-right: .375rem;
      }
    }
    .dtr-footer-date {
      font-size: .75rem;
    }
  }
  @media (min-width: 768px) {
    .ranges {
      float: left;
      ul {
        display: block;
        padding: .75rem;
        li:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>